import type { i18n } from 'i18next'
import { formatDateSpan, formatDistance, getDateFormatter, WEEKDAY_DAY_FORMAT } from './dates'

export const registerFormatters = (i18n: i18n) => {
  i18n.services.formatter?.add('dtshort2', getDateFormatter('eeeeee d.M. HH:mm'))
  i18n.services.formatter?.add('dtshort3', getDateFormatter('eee d.M. HH:mm'))
  i18n.services.formatter?.add('wdshort2', getDateFormatter(WEEKDAY_DAY_FORMAT))
  i18n.services.formatter?.add('weekday2', getDateFormatter('eeeeee'))
  i18n.services.formatter?.add('wdshort3', getDateFormatter('eee d.M.'))
  i18n.services.formatter?.add('weekday3', getDateFormatter('eee'))
  i18n.services.formatter?.add('short', getDateFormatter('dd.MM.'))
  i18n.services.formatter?.add('datespan', formatDateSpan)
  i18n.services.formatter?.add('distance', formatDistance)
  i18n.services.formatter?.add('lowercase', (value) => value.toLowerCase())
  i18n.services.formatter?.add('date', getDateFormatter('d.M.yyyy'))
  i18n.services.formatter?.add('isodate', getDateFormatter('dd.MM.yyyy'))
  i18n.services.formatter?.add('long', getDateFormatter('dd.MM.yyyy HH:mm'))
  i18n.services.formatter?.add('time', getDateFormatter('HH:mm'))
}
